export const placementTypes = {
  Assignment: 1,
  DirectPlacement: 2,
  Deal: 3
}
